import request from '@/utils/request';
//优惠券列表
export function getCpDataList(values) {
  return request('/coupon/queryDataPage', {
    method: 'POST',
    data: values,
  });
}
export function getOrderId(values) {
  return request('/order/queryOrderId', {
    method: 'POST',
    data: values,
  });
}
//订单详情
export function getOrderDetail(values) {
  return request('/order/queryOrderDetail', {
    method: 'POST',
    data: values,
  });
}
//下载
export function downloadDataPage(values) {
  return request('/coupon/downloadDataPage', {
    method: 'POST',
    data: values,
  });
}
//总金额
export function queryDataAmountPaid(values) {
  return request('/coupon/queryDataAmountPaid', {
    method: 'POST',
    data: values,
  });
}
